module.exports = __webpack_public_path__ + "static/img/invest-consume7.1ca9a43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume7.jpg
// module id = cOBS
// module chunks = 0